
import { Options, Vue } from "vue-class-component";
import address, { filePath } from "@/variable";
import axios from "axios";
import { useStore } from "vuex";

@Options({
  components: {},
})
export default class Form extends Vue {
  doc: any = {};
  lgs: Array<any> = [];
  brands: Array<any> = [];
  details: Array<any> = [];
  diameters: Array<any> = [];
  lengthPeriods: Array<any> = [];
  spirals: Array<any> = [];
  status: Array<any> = [];
  store = useStore();
  filePath = filePath;
  mounted() {
    if (this.$route.params.id != undefined) this.fetchData();
    axios.get(`${address}/code-by-field/name/Launching Girders`).then((response) => {
      this.lgs = response.data.member;
    });
    axios.get(`${address}/code-by-field/name/PTBar Brand`).then((response) => {
      this.brands = response.data.member;
    });
    axios.get(`${address}/code-by-field/name/PTBar Detail`).then((response) => {
      this.details = response.data.member;
    });
    axios.get(`${address}/code-by-field/name/PTBar Diameter`).then((response) => {
      this.diameters = response.data.member;
    });
    axios.get(`${address}/code-by-field/name/PTBar Length Period`).then((response) => {
      this.lengthPeriods = response.data.member;
    });
    axios.get(`${address}/code-by-field/name/PTBar Spiral`).then((response) => {
      this.spirals = response.data.member;
    });
    axios.get(`${address}/code-by-field/name/PTBar Status`).then((response) => {
      this.status = response.data.member;
    });
  }
  fetchData() {
    axios.get(`${address}/ptbar/${this.$route.params.id}`).then((response) => {
      this.doc = response.data;
    });
  }
  submitForm() {
    if (this.$route.params.id != undefined) {
      axios
        .patch(`${address}/ptbar/${this.doc._id}`, this.doc)
        .then((response) => {
          alert("แก้ไขข้อมูลแล้ว");
          this.$router.push("/ptbar");
        });
    } else {
      axios
        .post(`${address}/ptbar`, {
          ...this.doc,
        })
        .then((response) => {
          alert("บันทึกข้อมูลแล้ว");
          // console.log(response)
          this.$router.push("/ptbar");
        });
    }
  }
}
